<template>
  <v-card>
    <v-toolbar dense color="red lighten-1" dark>
      <v-toolbar-title>Requisições de troca de escala</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <template v-for="(swap, index) in swaps_received">
          <v-list-item v-if="swap.employee_approval == null" :key="index">
            <v-row class="d-flex elevation-2 my-2 align-center" style="border-radius: 5px">
              <v-col
                cols="12"
                lg="3"
                md="3"
                sm="4"
                class="d-flex flex-column align-center pa-0"
                style="flex: 1"
                fill-height
              >
                <p class="pa-6 my-2 white--text" style="border-radius: 4px" :style="getColor(swap)">
                  {{ swap.scale_type.initials }}
                </p>
              </v-col>
              <v-col cols="12" lg="7" md="7" sm="8">
                <p class="ma-0">De: {{ swap.from }}</p>
                <p class="ma-0">Dia: {{ getFormatedDate(swap.date) }}</p>
                <p class="ma-0">Tipo: {{ swap.scale_type.name }}</p>
                <p class="ma-0">Carga horária: {{ swap.scale_type.workload }}h</p>
              </v-col>
              <v-col cols="12" lg="2" md="2" sm="2" class="d-flex justify-end">
                <div class="buttons-container">
                  <v-btn color="red" dark class="mb-2" @click="updateReceivedSwap(false, swap)"
                    >Recusar</v-btn
                  >
                  <v-btn color="green" dark @click="updateReceivedSwap(true, swap)">Aceitar</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
        </template>
        <template v-if="swaps_received.length == 0">
          <v-container fluid class="d-flex justify-center">
            <span
              class="pa-10"
              style="
                color: #666;
                font-size: 24px;
                background-color: rgba(0, 0, 0, 0.1);
                border-radius: 8px;
              "
              >Nenhuma solicitação pendente.</span
            >
          </v-container>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { formatDateToShow } from '@/global/functions'
export default {
  name: 'ReceivedSwapList',
  data: () => {
    return {}
  },
  computed: {
    ...mapState('scales', ['swaps_received']),
  },
  methods: {
    ...mapActions('scales', ['ActionUpdateSwapRequest']),
    ...mapActions('ui', ['ActionSetLoading']),
    getColor(swap) {
      return `background-color: ${swap.scale_type.color}`
    },
    getFormatedDate(date) {
      return formatDateToShow(date).split(' ')[0]
    },
    async updateReceivedSwap(value, swap) {
      this.ActionSetLoading(true)
      try {
        await this.$swal({
          icon: 'warning',
          title: 'Atenção',
          showCancelButton: true,
          text: `Você realmente deseja ${value ? 'aceitar' : 'recusar'} a solicitação?`,
        }).then(async (response) => {
          if (response.isConfirmed) {
            const payload = { ...swap, employee_approval: value }
            await this.ActionUpdateSwapRequest(payload)
            this.$swal({
              icon: 'success',
              title: 'Respondido',
              html: `Você ${value ? 'aceitou' : 'recusou'} a solicitação.${
                value
                  ? `<br> Agora a aprovação depende do seu coordenador, aguarde.<br> Caso ele aprove aparecerá na sua escala um novo dia de trabalho.`
                  : ''
              }`,
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
      this.ActionSetLoading(false)
    },
  },
}
</script>

<style>
.buttons-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

@media (min-width: 320px) and (max-width: 659px) {
  .buttons-container {
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }
}
</style>
